import { Charger } from "shared-types";

export const availableChargers: Charger[] = [
  {
    id: 1,
    name: "Heimsteckdose",
    power: 2,
    disclaimer:
      "Mindestladezeit an einer Heimsteckdose mit 2.3 kW, Versorgungsspannung 230 V, Strom 10 A (1-phasig).",
  },
  {
    id: 2,
    name: "Wallbox",
    power: 11,
    disclaimer:
      "Mindestladezeit an einer Wallbox mit 11 kW, Versorgungsspannung 230 V, Strom 10 A (3-phasig).",
  },
  {
    id: 3,
    name: "AC-Ladestation",
    power: 22,
    disclaimer:
      "Mindestladezeit an einer AC-Ladestation mit 22 kW, Versorgungsspannung 400 V, Strom 32 A.",
  },
  {
    id: 4,
    name: "DC-Schnellladung (bis zu 350kw)",
    power: 350,
    disclaimer: "Mindestladezeit an einer DC-Schnellladung mit 350 kW.",
  },
  {
    id: 5,
    name: "DC-Schnellladung (bis zu 50kw)",
    power: 50,
    disclaimer: "Mindestladezeit an einer DC-Schnellladung mit 50 kW.",
  },
];

export const defaultCharger = availableChargers[2];
